import React, { Component, Fragment } from "react";
import FooterDesktop from "../components/common/FooterDesktop";
import MainHeader from "../components/common/MainHeader";
import Testimonial from "../components/home/Testimonial";
import Banner from "../components/home/Banner";
import WhatWeOffer from "../components/home/WhatWeOffer";
import DomesticExplorer from "../components/home/DomesticExplorer";
import InternationalExplorer from "../components/home/InternationalExplorer";
import SocialMediaCounter from "../components/home/SocialMediaCounter";
import HotPackageTour from "../components/home/HotPackageTour";
import Newsletter from "../components/home/Newsletter";
import AboutAdorablevacation from "../components/home/AboutAdorablevacation";
import OthersPackages from "../components/home/OthersPackages";
import Album from "../components/home/Album"
import { Helmet } from "react-helmet";

class HomePage extends Component {
   handleClick = () => {
          const currentUrl = window.location.href;
          const pageTitle = document.title;
          const message = `Hi, Please send about the Tour Package details "${pageTitle}"`;
          // Push custom event to GTM
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              event: 'whatsappSubmissionSuccess',
              formId: 'whatsappback' // Example form ID
          });
          const whatsappLink = `https://api.whatsapp.com/send?phone=+919883359713&text=${encodeURIComponent(message + ' ' + currentUrl)}`;
          window.open(whatsappLink, '_blank');
      };
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>Home</title>
        </Helmet>

        <MainHeader />
        <Banner />
        <AboutAdorablevacation />
        <WhatWeOffer />
        {/* <DomesticExplorer /> */}
        <OthersPackages />
        <InternationalExplorer />
        <Testimonial />
        <Album />
        <HotPackageTour />
        <Newsletter />

        <FooterDesktop />
        <div className="btn-whatsapp-pulse">
                    <a style={{ color: 'white' }} href="#" onClick={this.handleClick}>
                        <i className="fab fa-whatsapp"></i>
                    </a>
                </div>
      </Fragment>
    );
  }
}

export default HomePage;
